export async function getAllSectionsBase(apiUrl: string) {
  try {
    const response = await fetch(`${apiUrl}/api/v4/self-service-balloon/sections`)
    if (!response.ok) throw new Error('Erro ao buscar dados')
    const { data } = await response.json()
    return data
  } catch (error) {
    console.error(error)
  }
}

export async function getSection(apiUrl: string, module: string) {
  try {
    const response = await fetch(`${apiUrl}/api/v4/self-service-balloon/section/${module}/content`)
    if (!response.ok) throw new Error('Erro ao buscar dados')
    const { data } = await response.json()
    return data
  } catch (error) {
    console.error(error)
  }
}
